import { render, staticRenderFns } from "./EventManagerLogotype.vue?vue&type=template&id=5d7c8e7a&"
import script from "./EventManagerLogotype.vue?vue&type=script&lang=js&"
export * from "./EventManagerLogotype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports